
import getCssValue from './get-css-value'

export default function isCustomCssValueSet( selector, css, size = window.stlst_legacy.get_media_condition(), source ) {
	return getCssValue( {
		cssSelector: selector,
		cssProperty: css,
		responsiveSize: size,
		cssCode: source
	} )
}


// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/is-custom-css-value-set.js